/**
 * Created by slava on 5/4/17.
 */

const ErrorHandler = {
    MESSAGES: {
        connection: {
            title: "RestartWindow.Connection.Title",
            description: "RestartWindow.Connection.Description",

            titleFallback: "No internet connection",
            descriptionFallback: "Check your connection and try again."
        },

        server: {
            title: "RestartWindow.Server.Title",
            description: "RestartWindow.Server.Description",

            titleFallback: "Couldn't load the game",
            descriptionFallback: "Something went wrong on our side. Please try again in a moment."
        },

        context_lost: {
            title: "RestartWindow.ContextLost.Title",
            description: "RestartWindow.ContextLost.Description",

            titleFallback: "Graphics problem",
            descriptionFallback: "Graphics stopped working in your browser."
        },

        context_lost_limit: {
            title: "RestartWindow.ContextLostLimit.Title",
            description: "RestartWindow.ContextLostLimit.Description",

            titleFallback: "Graphics problem",
            descriptionFallback: "Close your browser completely, then open the game again."
        },

        unknown: {
            title: "RestartWindow.Unknown.Title",
            description: "RestartWindow.Unknown.Description",

            titleFallback: "Something went wrong",
            descriptionFallback: "Please reload the game to continue."
        }
    },

    reload: function () {
        if (this.reloading) {
            return;
        }
        this.reloading = true;

        if (cleverapps.metrics) {
            cleverapps.metrics.logEvent(cleverapps.EVENTS.DEBUG.ERROR_RELOAD);
            cleverapps.metrics.sendEventsNow();
        }

        if (cleverapps.dataLoader) {
            cleverapps.dataLoader.processSaveQueue();
        }

        setTimeout(() => {
            if (window.connector && connector.platform && connector.platform.locationReload) {
                connector.platform.locationReload();
            } else {
                window.location.reload();
            }
        }, 100);
    },

    showRestartWindow: function (options) {
        if (this.restartWindowShown || cleverapps.environment && cleverapps.environment.isSceneWithPreview()) {
            return;
        }
        this.restartWindowShown = true;

        let cause = options.cause;

        if (!cause) {
            if (navigator.onLine === false) {
                cause = "connection";
            } else {
                const noAnswer = (options.errors || []).every((error) => [0, cc.LOAD_TIMEOUT_STATUS, cc.LOAD_ERROR_STATUS].includes(error.status));
                cause = noAnswer ? "connection" : "server";
            }
        }

        if (!this.MESSAGES[cause]) {
            cause = "unknown";
        }

        const screen = cleverapps.environment && cleverapps.environment.getScreen();

        if (cleverapps.metrics) {
            cleverapps.metrics.logEvent(cleverapps.EVENTS.SYSTEM.RESTART_WINDOW, { itemId: screen, error: cause });
        }

        const retry = Boolean(options.onRetry) && (options.retries || 0) < this.RETRIES_LIMIT;

        const windowOptions = {
            messages: this.MESSAGES[cause],
            retryDelay: options.retryDelay,
            onReload: options.onReload,
            onRetry: retry ? () => {
                this.restartWindowShown = false;

                if (cleverapps.config.debugMode) {
                    cleverapps.PageSession.remove("simulatedLoadError");
                }

                cleverapps.metrics.logEvent(cleverapps.EVENTS.SYSTEM.RESTART_WINDOW_RETRY, { itemId: screen, error: cause });

                options.onRetry();
            } : undefined
        };
        if (this.isOnlyHtmlWindowAvailable()) {
            HtmlRestartWindow.show(windowOptions);
        } else {
            new RestartWindow(windowOptions);
        }
    },

    isOnlyHtmlWindowAvailable: function () {
        return this.contextLost
            || !cleverapps.resolution || !cleverapps.resolution.shown
            || !cleverapps.bundleLoader || !cleverapps.bundleLoader.isLoaded(["main", "ui"])
            || !cc.director || !cleverapps.Scenes.GetRunningScene();
    },

    formatMessage: function (lines) {
        let message = [`${new Date()}`];

        if (cleverapps.environment) {
            message.push(`Screen: ${cleverapps.environment.getScreen()}`);
        }

        if (window.connector && connector.info) {
            message.push(`Source: ${connector.info.source}`);
        }

        if (cleverapps.config) {
            message.push(`Name: ${cleverapps.config.name}`);
            message.push(`Version: ${cleverapps.config.version}`);
            message.push(`WebpSupport: ${cleverapps.config.webpSupport}`);
        }

        if (cleverapps.user) {
            if (cleverapps.environment) {
                message.push(`Episode: ${cleverapps.environment.episodeNo}`);
                message.push(`Level: ${cleverapps.environment.levelNo}`);

                if (cleverapps.environment.locationId !== undefined) {
                    message.push(`Location: ${cleverapps.environment.locationId}`);
                }
            }

            if (cleverapps.config && ["merge", "merge2"].includes(cleverapps.config.type)) {
                message.push(`User Level: ${cleverapps.user.currentPhysicalLevel.level}`);
            } else if (cleverapps.config && cleverapps.config.type === "match3") {
                message.push(`User Level: ${cleverapps.user.getHumanReadableNumber()}`);
            } else {
                message.push(`User Level: ${cleverapps.user.currentPhysicalLevel.episode}`);
            }

            message.push(`User id: ${connector.platform.getUserID()}`);
        }

        if (cleverapps.paymentsHistory) {
            message.push(`Payer: ${cleverapps.paymentsHistory.classify()}`);
        }

        if (cleverapps.settings) {
            message.push(`Language: ${cleverapps.settings.language}`);
        }

        if (cleverapps.focusManager) {
            message.push(`Focus: ${cleverapps.focusManager.focus}`);
            message.push(`Focus history: ${cleverapps.focusManager.focusHistory.join(", ")}`);
        }

        if (typeof $msstart !== "undefined") {
            message.push(`Last $msstart: ${$msstart.lastCalled} ${$msstart.lastCalledTime}`);
        }

        message.push((window && window.navigator) ? window.navigator.userAgent : "???");

        message = message.concat(lines);
        message = message.join(" - ");
        message = `${message.replace(/(?:\r\n|\r|\n)/g, " - ")} `;

        if (window && window.assetsFolder) {
            message = message.replace(new RegExp(window.assetsFolder, "g"), "");
        }

        return cleverapps.truncateToBytes(message, ErrorHandler.MAX_MESSAGE_LENGTH);
    },

    onError: function (event, needSend) {
        const message = event.message;
        const url = event.filename || window.location.href;
        const lineNo = event.lineno;
        const columnNo = event.colno;
        const error = event.error;

        const lines = [];

        if (error && error.arguments) {
            lines.push(`Arguments: ${error.arguments}`);
        }

        if (error && error.frameErrors) {
            lines.push(`Frame errors: ${error.frameErrors}`);

            if (error.frameErrors === 1 && cleverapps.metrics) {
                cleverapps.metrics.logEvent(cleverapps.EVENTS.DEBUG.FRAME_ERROR);
            }
        }

        if (!error || !error.stack) {
            lines.push(`Message: ${message}`);
            lines.push(`URL: ${url}`);
            lines.push(`Line: ${lineNo}`);
            lines.push(`Column: ${columnNo}`);
            lines.push(`Error: ${JSON.stringify(error)}`);
        } else {
            lines.push(`Message: ${message}`);
            lines.push(`URL: ${url}`);
            lines.push(`Line: ${lineNo}`);
            lines.push(`Column: ${columnNo}`);
            lines.push(error.stack);
        }

        this.getLastConsoleMessages((consoleMessages) => {
            if (consoleMessages) {
                lines.unshift(`Console: ${consoleMessages}`);
            }

            const formattedMessage = this.formatMessage(lines);

            this.showErrorNotification(error || message, lines);

            if (needSend) {
                this.send(formattedMessage);
            }
        });

        return false;
    },

    send: function (message) {
        const path = cleverapps.config.deployment + ErrorHandler.LOG_ERROR_URL;

        if (cleverapps.metrics) {
            cleverapps.metrics.logEvent(cleverapps.EVENTS.SYSTEM.JS_ERROR);
        }

        console.log(message);
        cleverapps.RestClient.sendRaw(cleverapps.RestClient.METHODS.POST, path, message);
    },

    getLastConsoleMessages: function (callback) {
        if (!window.connector || !connector.platform.oneOf(
            connector.RUSTORE, 
            connector.AMAZON, 
            connector.ANDROID,
            connector.DIGITAL, 
            connector.EPICGAMES, 
            connector.IOS, 
            connector.MACOS
        )) {
            callback();
            return;
        }

        try {
            connector.platform.callNative("ConsolePlugin.getLastConsoleMessages", (code, data) => {
                callback(data && data.consoleMessages);
            });
        } catch (e) {
            console.log("ErrorHandler.getLastConsoleMessages error", e);
            callback();
        }
    },

    showErrorNotification: function (error, details) {
        if (!cleverapps.config.debugMode || !cleverapps.bundleLoader || !cleverapps.notification) {
            return;
        }

        let message;

        if (typeof error === "string") {
            message = error;
        } else if (error && error.message) {
            message = error.message;
        } else {
            message = JSON.stringify(error);
        }

        message = message.substr(0, 60);

        cleverapps.notification.create(message, {
            defer: true,
            image: bundles.dev_buttons.frames.icon_error,
            debugInfo: details.join("\n")
        });

        if (cleverapps.resolution && cleverapps.resolution.isInitialized()) {
            cleverapps.bundleLoader.loadBundles(["main", "ui"], {
                onSuccess: function () {
                    cleverapps.resolution.showCanvas();
                    cleverapps.notification.processQueue();
                    cleverapps.bundleLoader.deleteBundle("main");
                    cleverapps.bundleLoader.deleteBundle("ui");
                }
            });
        }
    }
};

ErrorHandler.LOG_ERROR_URL = "/log/";
ErrorHandler.MAX_MESSAGE_LENGTH = 8 * 1024;

// in-place retries of a failed load before the window offers a reload instead
ErrorHandler.RETRIES_LIMIT = 3;

// a frame that threw: reported through throwAsync so WeChat and the webviews get it the same way as any other error
ErrorHandler.onFrameError = function (error) {
    cleverapps.throwAsync(error.message, error);
};

// MAX_FRAME_ERRORS frames in a row threw and the engine paused: the scene cannot draw a window either, so the only
// recovery is a reload. Capped per session so a scene broken on every start does not reload forever
ErrorHandler.FRAME_LOOP_RELOADS_LIMIT = 2;
ErrorHandler.FRAME_LOOP_RELOADS_PERIOD = 10 * 60 * 1000;

ErrorHandler.onFrameLoopBroken = function () {
    const now = Date.now();
    let reloads = cleverapps.PageSession.get("frameLoopReloads");
    if (!reloads || !reloads.count || now - reloads.since > this.FRAME_LOOP_RELOADS_PERIOD) {
        reloads = { count: 0, since: now };
    }

    const giveUp = reloads.count >= this.FRAME_LOOP_RELOADS_LIMIT;

    if (cleverapps.metrics) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.DEBUG.FRAME_LOOP_BROKEN, { itemId: giveUp ? "stop" : "reload" });
    }

    if (giveUp) {
        return;
    }

    reloads.count++;
    cleverapps.PageSession.set("frameLoopReloads", reloads);

    this.reload();
};

// The WebGL context is gone and the engine cannot restore one, so the page reloads. The first loss in a while: the usual
// case (a few percent of web DAU every day), the reload at once brings the game back. Lost again soon after: the browser
// refuses contexts for now - Safari keeps the previous page's context for about a minute after a crash or a reload and
// hands out dead or soon-dropped ones meanwhile - so an immediate reload loses it again, and reloading at once looped
// every couple of seconds, flooding metrics. Every loss counts in one sessionStorage counter that expires after
// CONTEXT_LOST_RELOADS_PERIOD, not on a successful start - in Safari the start succeeds and the context drops right after.
// A repeated loss waits CONTEXT_LOST_RETRY_DELAY behind a message, and past CONTEXT_LOST_RELOADS_LIMIT the message asks
// to restart the browser instead. Both messages keep a Reload button, the player may always try at once
ErrorHandler.CONTEXT_LOST_RELOADS_LIMIT = 3;
ErrorHandler.CONTEXT_LOST_RELOADS_PERIOD = 10 * 60 * 1000;
ErrorHandler.CONTEXT_LOST_RETRY_DELAY = 60 * 1000;

ErrorHandler.onContextLost = function () {
    this.contextLost = true;

    if (cleverapps.playSession) {
        this.logContextLost();
    }
    if (cc.director) {
        cc.director.stopAnimation();
    }

    const now = Date.now();
    let reloads = cleverapps.PageSession.get("contextLostReloads");
    if (!reloads || !reloads.count || now - reloads.since > this.CONTEXT_LOST_RELOADS_PERIOD) {
        reloads = { count: 0, since: now };
    }

    reloads.count++;
    reloads.logged = false;
    cleverapps.PageSession.set("contextLostReloads", reloads);

    if (reloads.count === 1 && cleverapps.playSession) {
        this.reload();
        return;
    }

    // the counter stays on a manual reload: while it lasts, every further loss asks again to restart the browser
    if (reloads.count > this.CONTEXT_LOST_RELOADS_LIMIT) {
        this.showRestartWindow({
            cause: "context_lost_limit"
        });
        return;
    }

    this.showRestartWindow({
        cause: "context_lost",
        retryDelay: this.CONTEXT_LOST_RETRY_DELAY
    });
    setTimeout(() => this.reload(), this.CONTEXT_LOST_RETRY_DELAY);
};

ErrorHandler.logContextLost = function () {
    cleverapps.playSession.logEventOnce(cleverapps.EVENTS.WEBGL.CONTEXT_LOST_DAU);
    if (cleverapps.playSession.get(cleverapps.EVENTS.WEBGL.CONTEXT_LOST)) {
        cleverapps.playSession.logEventOnce(cleverapps.EVENTS.WEBGL.CONTEXT_LOST_MULTIPLE);
    }
    cleverapps.playSession.inc(cleverapps.EVENTS.WEBGL.CONTEXT_LOST);
    cleverapps.playSession.logEvent(cleverapps.EVENTS.WEBGL.CONTEXT_LOST, {
        itemId: cleverapps.environment.getScreen()
    });

    if (cc.game.isPaused()) {
        cleverapps.playSession.logEvent(cleverapps.EVENTS.WEBGL.CONTEXT_LOST_INACTIVE);
        cleverapps.playSession.logEventOnce(cleverapps.EVENTS.WEBGL.CONTEXT_LOST_INACTIVE_DAU);
    }
};

// called once the game is up: the losses that preceded this start become one event, counter = how many. The counter
// itself stays until it expires, a start is no proof the context will hold
ErrorHandler.logContextLostReloads = function () {
    const reloads = cleverapps.PageSession.get("contextLostReloads");
    if (!reloads || !reloads.count || reloads.logged) {
        return;
    }

    cleverapps.metrics.logEvent(cleverapps.EVENTS.DEBUG.CONTEXT_LOST_BOOT, { counter: reloads.count });

    reloads.logged = true;
    cleverapps.PageSession.set("contextLostReloads", reloads);
};

if (window.cc && cc.game) {
    cc.game.onFrameError = ErrorHandler.onFrameError.bind(ErrorHandler);
    cc.game.onFrameLoopBroken = ErrorHandler.onFrameLoopBroken.bind(ErrorHandler);
    cc.game.onContextLost = ErrorHandler.onContextLost.bind(ErrorHandler);
}

window.addEventListener("connector:globalError", (event) => {
    const originalEvent = event.detail.originalEvent;
    const needSend = event.detail.needSend;

    ErrorHandler.onError(originalEvent, needSend);
});

Error.stackTraceLimit = 30;